import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, ComponentFactoryResolver,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';
import { FrameService } from '../frame.service';
import {Scene1Floor, Scene2Floor, Scene3Floor, Scene4Floor, Scene5Floor, Scene6Floor, Scene7Floor} from '../../../assets/config/frames/scene.enum';
import {FloorService} from '../../shared/services/floor.service';

@Component({
  selector: 'app-frame-wrapper',
  templateUrl: './frame.component.html',
  styleUrls: ['./frame.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FrameComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('anchor', { read: ViewContainerRef }) anchor: ViewContainerRef;
  floors = [Scene1Floor, Scene2Floor, Scene3Floor, Scene4Floor, Scene5Floor, Scene6Floor, Scene7Floor];

  @Input() src: string;

  iframeSrc: SafeUrl;
  selectedFrame: any;
  isVisible = false;

  constructor(
    public sanitizer: DomSanitizer,
    public frameService: FrameService,
    private changeDetection: ChangeDetectorRef,
    public floorService: FloorService,
  ) { }

  ngOnInit(): void {
    this.frameService.selectedFrame.subscribe(async (frame: any) => {
      if (!frame){
        return;
      }
      this.selectedFrame = frame;
      this.frameService.visible = true;
      this.changeDetection.detectChanges();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  close(): void {
    if (this.anchor) {
      this.anchor.clear();
    }
    this.frameService.close();
  }

  ngOnDestroy() {
  }
}
